import { type MessagesByLanguage } from '../types/i18n/i18n.type';
import { esClTranslations } from './es-CL';
import { enUsTranslations } from './en-US';

/**
 * All base translations organized by language
 */
export const baseMessages: MessagesByLanguage = {
  'es-CL': esClTranslations,
  'en-US': enUsTranslations,
};
